export class Filter {
  filter: string;
  checked: boolean;
  index: number;

  constructor(filter: string, checked: boolean, index: number) {
    this.filter = filter;
    this.checked = checked;
    this.index = index;
  }
}
